import './js/anchor__customer'
import './js/anchor__logged_in_user_customer'
import './js/anchor__logged_in_user'
import './js/customajax'
import './js/anchor__booking_interaction'
import './js/anchor__front-end'